import React from "react";

type PictureProps = {
    webpSrc?: string;
    pngSrc?: string;
    jpgSrc?: string;
    alt: string;
    className?: string;
    loading?: "eager" | "lazy";
    fetchPriority?: "high" | "low" | "auto";
    sizes?: string;
    style?: React.CSSProperties;
    onErrorSrc?: string; // network/404 fallback URL
};

export const Picture: React.FC<PictureProps> = ({
    webpSrc,
    pngSrc,
    jpgSrc,
    alt,
    className,
    loading,
    fetchPriority,
    sizes,
    style,
    onErrorSrc,
}) => {
    const fallbackSrc = pngSrc || jpgSrc || webpSrc || "";

    const picture = (
        <>
            {webpSrc && <source srcSet={webpSrc} type="image/webp"/>}
            {pngSrc && <source srcSet={pngSrc} type="image/png" />}
            {jpgSrc && <source srcSet={jpgSrc} type="image/jpeg" />}
            <img
                src={fallbackSrc}
                alt={alt}
                className={`${className} m-auto`}
                loading={loading}
                fetchPriority={fetchPriority}
                sizes={sizes}
                style={style}
                onError={(e) => {
                    if (!onErrorSrc) return;
                    const target = e.currentTarget as HTMLImageElement;
                    target.onerror = null;
                    target.src = onErrorSrc;
                }}
            />
        </>
    );

    return webpSrc || pngSrc || jpgSrc ? <picture>{picture}</picture> : picture;
};

export default Picture;


